import { useEffect, useState } from 'react';

export interface Countdown {
  days: number;
  hours: number;
  minutes: number;
  ended: boolean;
}

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export function computeCountdown(target: string | Date, now: Date = new Date()): Countdown {
  const end = new Date(target).getTime();
  const diff = end - now.getTime();
  if (Number.isNaN(end) || diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, ended: true };
  }
  return {
    days: Math.floor(diff / DAY),
    hours: Math.floor((diff % DAY) / HOUR),
    minutes: Math.floor((diff % HOUR) / MINUTE),
    ended: false
  };
}

export function useCountdown(target: string | Date): Countdown {
  const [countdown, setCountdown] = useState<Countdown>(() => computeCountdown(target));

  useEffect(() => {
    setCountdown(computeCountdown(target));
    const id = setInterval(() => setCountdown(computeCountdown(target)), 30 * 1000);
    return () => clearInterval(id);
  }, [target]);

  return countdown;
}
